export default __webpack_public_path__ + "static/media/2019.0d0addd8.pdf";